import { characterSelector, useHudStore } from "@/domains/hud/store";
import HudWantedLevel from "@/domains/hud/components/HudWantedLevel";

export default function HudWantadLevelContainer() {
  const character = useHudStore(characterSelector);

  if (!character?.wantedLevel) return null;

  return <HudWantedLevel level={character.wantedLevel || 0} />;
}
